define(['jquery',
        'core/urls',
        'core/utilities',
        'core/browser-storage',
        'core/loading-animation',
        'components/selectize',
        'quill',
        "quill-delta",
        "components/modal",
    ],
    function (
        $, 
        reverse_url, 
        utilities, 
        browser_storage, 
        loading_animation, 
        selectize_util, 
        Quill, 
        Delta,
        modal,
        ) {

        let nodes = {
            wrapper: document.querySelector(".container-fluid.automation-rules"),
            modal: {
                modal: document.querySelector(".modal_js"),
                close: document.querySelector(".modal-close_js"),
                content: document.querySelector(".modal-content_js"),
                title: document.querySelector(".modal-title_js"),
                bg: document.querySelector(".modal-bg_js"),
                blur: [
                    document.querySelector(".sidebar-nav"),
                    document.querySelector(".navigation-top")
                ],
            },
            emailPreview: {
                button: document.querySelector("button.preview-email"),
                modalTemplate: document.querySelector(".modal-template-email-preview"),
                logo: document.querySelector(".modal-template-email-preview .logo"),
                body: document.querySelector(".modal-template-email-preview .body"),
            }
        }

        let tssType = nodes.wrapper.dataset.tssType;
        let createdModal;

        if(tssType === "cw") {
            createdModal = modal.create(nodes.modal, function (el) {});
        }

        let quill;
        let quillInitiated = false;

        var XHR_TIMEOUT = 30 * 1000,
            DEFAULT_MESSAGE_API_ERROR = 'Unable to reach ConnectWise PSA. Please check your integration settings and reload the page.';

        // A polyfill for ECMA-262's Object.values() (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/values)
        // from https://stackoverflow.com/a/42830295/6278
        function Object_values_polyfill(obj) {
            return Object.keys(obj).map(function (e) {
                return obj[e];
            });
        }

        function toggleWidgetToState(widget, newState) {
            if (widget.is(':visible') !== newState) {
                widget.toggleClass('show', newState);
            }
        }

        function setVisibility(widget, newState) {
            if (newState) {
                widget.addClass('show');
            }
        }

        let pathname = window.location.pathname;
        let ruleID = pathname.split("/")[2];

        // Handles different form states such as disabling the submit button while data is loaded.
        // Also, it locks the form if existing data cannot be verified and would otherwise be overwritten.
        var SelectizedForm = {
            _VALIDATION_ATTRIBUTE: 'data-validation-message',
            $submit: $('#automation-edit-button-save'),
            _alertClasses: function () {
                // all known alert classes depending on hint type
                return {
                    error: 'alert-danger',
                    warning: 'alert-warning'
                };
            },
            _alertClass: function (type) {
                if (this._alertClasses().hasOwnProperty(type)) {
                    return this._alertClasses()[type];
                }
            },
            _allAlertClasses: function () {
                Object_values_polyfill(this._alertClasses()).join(' ');
            },
            // displays a problem depending on the given `type`.
            // this could be a warning or an error:
            // * error displays a red alert and causes the submit button to be disabled
            // * warning displays a yellow alert and still allows submitting the form
            _displayProblem: function (selectize, type) {
                var self = this;

                self._addProblemMessage(selectize, type);

                selectize.$input.siblings('p.alert').removeClass('collapse').addClass(self._alertClass(type));

                selectize.disable();
            },
            _hasErrors: function () {
                return $('form.form-horizontal').find('.' + this._alertClass('error') + ':not(.collapse):not(.ignore)').length > 0;
            },
            _addProblemMessage: function (selectize, type) {
                var self = this;

                function _wrapperClass() {
                    if (type === 'error') {
                        return 'has-error';
                    } else if (type === 'warning') {
                        return 'has-warning';
                    }
                }

                selectize.$wrapper.addClass('has-feedback ' + _wrapperClass());
                selectize.$wrapper.parents('div.form-group').addClass('with-alert-box');
            },
            // returns the first validation error message found
            _getErrorMessage: function () {
                if (this._hasErrors()) {
                    return $('form.form-horizontal')
                        .find('p.' + this._alertClass('error') + ':not(.collapse)')
                        .first().attr(this._VALIDATION_ATTRIBUTE);
                }
            },
            _reset: function () {
                var self = this;

                self.$submit.removeClass('disabled');

                self.$submit.off('click');
                self.$submit.on('click', function (event) {
                    if (self.$submit.hasClass('disabled')) {
                        // ensure form cannot be submitted due to validation errors
                        event.stopPropagation();
                    } else {
                        // restore the original click handler
                        onSaveButton(event);
                    }
                });
            },
            _error: function (message) {
                var self = this;

                self.$submit.addClass('disabled');
            },
            // update the form and enable or disable the button
            _render: function () {
                var self = this;
                if (!self._hasErrors()) {
                    self._reset();
                } else {
                    self._error();
                }
            },
            loading: function () {
                var self = this;

                self._reset();
                self.$submit.addClass('disabled');
            },
            // errors are hints that would cause data removal and hence disable the form.
            // they display a red alert below the given selectize component and cause the submit button to be disabled.
            displayError: function (selectize) {
                this._displayProblem(selectize, 'error');
                this._render();
            },
            // warnings are hints that do not cause data removal and are therefore acceptable
            // they display a yellow alert below the given selectize component and still allow submitting the form.
            displayWarning: function (selectize) {
                this._displayProblem(selectize, 'warning');
                this._render();
            },
            // hide all existing errors for the given selectize component
            hideError: function (selectize) {
                var self = this;
                selectize.enable();

                selectize.settings.placeholder = selectize.$input.attr('placeholder') || selectize.$input.data('placeholder') || ' '; // requires at least a whitespace for updatePlaceholder() to run
                selectize.updatePlaceholder();

                selectize.$wrapper.removeClass('has-feedback')
                    .removeClass('has-error')
                    .removeClass('has-warning');
                selectize.$wrapper.parents('div.form-group').removeClass('with-alert-box');
                selectize.$control.find('.glyphicons.glyphicons-remove').remove();
                selectize.$control.find('.glyphicons.glyphicons-warning-sign').remove();
                selectize.$input.siblings('p.alert').addClass('collapse').removeClass(self._allAlertClasses());
                this._render();
            }
        };

        function fetchBoardsAndStatuses() {
            var xhr;
            var select_board, $select_board;
            var select_status, $select_status;

            $select_board = $('#action_board').selectize({
                plugins: selectize_util.plugins($('#action_board'), 'loading_spinner'),
                create: $(this).data('tags') === true,
                createOnBlur: $(this).data('tags') === true
            });
            $select_board.on('change', function (event) {
                $('#action_board_name').val(event.target.innerText);
                window.action_boards_and_statuses['selected'] = event.target.value;
            });

            $select_status = $('#action_status').selectize({
                plugins: $.extend({
                    'depends_on': {
                        onChange: function (value) {
                            select_status.disable();
                            select_status.clearOptions();

                            if (!value.length) return;

                            select_status.load(function (callback) {
                                SelectizedForm.loading();
                                xhr && xhr.abort();
                                xhr = $.ajax({
                                    type: 'GET',
                                    url: reverse_url['automation:board-statuses'](value),
                                    timeout: XHR_TIMEOUT,
                                    global: false,
                                    error: function () {
                                        callback();
                                        SelectizedForm.displayError(select_status);
                                    },
                                    success: function (data) {
                                        var options = [];
                                        SelectizedForm.hideError(select_status);
                                        data.forEach(function (status) {
                                            options.push({
                                                'value': status.id,
                                                'text': status.name
                                            });
                                        });
                                        callback(options);
                                        if (window.action_boards_and_statuses['selected'] && window.action_boards_and_statuses[window.action_boards_and_statuses['selected']]) {
                                            select_status.setValue(window.action_boards_and_statuses[window.action_boards_and_statuses['selected']]);
                                        }
                                        select_status.enable();
                                    }
                                })
                            });
                        }
                    },
                    'loading_spinner': {}
                }, selectize_util.pluginsAsObject($('#action_status'))),
                create: $(this).data('tags') === true,
                createOnBlur: $(this).data('tags') === true,
                onChange: function (value) {
                    if (value && value.length) {
                        window.action_boards_and_statuses[window.action_boards_and_statuses['selected']] = value;
                    }
                }
            });
            $select_status.on('change', function (event) {
                $('#action_status_name').val(event.target.innerText);
            });

            select_board = selectize_util.safeInstance($select_board);
            select_status = selectize_util.safeInstance($select_status);

            select_board.load(function (callback) {
                SelectizedForm.loading();
                xhr && xhr.abort();
                xhr = $.ajax({
                    type: 'GET',
                    url: reverse_url['automation:boards'](),
                    timeout: XHR_TIMEOUT,
                    global: false,
                    error: function () {
                        callback();
                        SelectizedForm.displayError(select_board);
                    },
                    success: function (data) {
                        var options = [];
                        SelectizedForm.hideError(select_board);
                        data.forEach(function (board) {
                            options.push({
                                'value': board.id,
                                'text': board.name
                            });
                        });
                        callback(options);
                        select_board.setValue(window.action_boards_and_statuses['selected']);
                    }
                });
            });
        }

        function fetchTicketTypes() {
            var xhr;
            var select_board, $select_board;
            var select_status, $select_status;

            $select_board = $('#action_ticket_type').selectize({
                plugins: selectize_util.plugins($('#action_ticket_type'), 'loading_spinner'),
                create: false,
                createOnBlur: false
            });
            $select_board.on('change', function (event) {
                $('#action_ticket_type_name').val(event.target.innerText);
            });

            select_board = selectize_util.safeInstance($select_board);
            let selected_board = $('#action_ticket_type').data('selected');

            select_board.load(function (callback) {
                SelectizedForm.loading();
                xhr && xhr.abort();
                xhr = $.ajax({
                    type: 'GET',
                    url: reverse_url['automation:boards'](),
                    timeout: XHR_TIMEOUT,
                    global: false,
                    error: function () {
                        callback();
                        SelectizedForm.displayError(select_board);
                    },
                    success: function (data) {
                        var options = [];
                        SelectizedForm.hideError(select_board);
                        data.forEach(function (board) {
                            options.push({
                                'value': board.id,
                                'text': board.name
                            });
                        });
                        callback(options);
                        select_board.setValue(selected_board);
                    }
                });
            });
        }

        function fetchTicketCategories() {
            var xhr;
            var select_board, $select_board;
            var select_status, $select_status;

            $select_board = $('#action_category').selectize({
                plugins: selectize_util.plugins($('#action_category'), 'loading_spinner'),
                create: false,
                createOnBlur: false
            });
            $select_board.on('change', function (event) {
                $('#action_category_name').val(event.target.innerText);
            });

            select_board = selectize_util.safeInstance($select_board);
            let selected_board = $('#action_category').data('selected');

            select_board.load(function (callback) {
                SelectizedForm.loading();
                xhr && xhr.abort();
                xhr = $.ajax({
                    type: 'GET',
                    url: reverse_url['automation:boards'](),
                    timeout: XHR_TIMEOUT,
                    global: false,
                    error: function () {
                        callback();
                        SelectizedForm.displayError(select_board);
                    },
                    success: function (data) {
                        var options = [];
                        SelectizedForm.hideError(select_board);
                        data.forEach(function (category) {
                            options.push({
                                'value': category.id,
                                'text': category.name
                            });
                        });
                        callback(options);
                        select_board.setValue(selected_board);
                    }
                });
            });
        }

        function loadData($element, value) {
            let xhr;
            let url = value ? reverse_url[$element.data('load-depended')](value) : reverse_url[$element.data('load')]();
            let $select_input_selectized = $element.selectize({
                plugins: selectize_util.plugins($element, 'loading_spinner'),
                create: false,
                createOnBlur: false
            })[0].selectize;
            let selected = $element.data('selected');

            $element.on('change', function (event) {
                $element.parent().find('.name_js').val(event.target.innerText);
                let action = $('#action_type').val();

                let deps = $('#' + action).find('[data-depends-on=' + $element.attr('id') + ']');
                if (deps.length) {
                    if (event.target.value) {
                        loadData(deps, event.target.value);
                    } else {
                        let s = deps.selectize({})[0].selectize
                        s.clearOptions();
                        s.addOption({
                            "value": "",
                            "text": deps.data('empty')
                        });
                        s.setValue("");

                    }
                }
            });

            $select_input_selectized.load(function (callback) {
                $select_input_selectized.disable();
                $select_input_selectized.clearOptions();
                SelectizedForm.loading();
                xhr && xhr.abort();
                xhr = $.ajax({
                    type: 'GET',
                    url: url,
                    timeout: XHR_TIMEOUT,
                    global: false,
                    error: function () {
                        callback();
                        SelectizedForm.displayError($select_input_selectized);
                    },
                    success: function (data) {
                        var options = [];
                        SelectizedForm.hideError($select_input_selectized);

                        if ($element.data('empty')) {
                            options.push({
                                'value': "",
                                'text': $element.data('empty')
                            });
                        }
                        data.forEach(function (category) {
                            options.push({
                                'value': category.id,
                                'text': category.name
                            });
                        });
                        callback(options);
                        if (selected) {
                            $select_input_selectized.setValue(selected);
                        } else {
                            $select_input_selectized.setValue("");
                        }
                    }
                });
            });
        }

        function initializeTriggerBoardsOnFocus() {
            // initialize trigger boards on focus only
            if ($('#trigger_boards').length) {
                var xhr;
                var trigger_board, $trigger_board;

                $trigger_board = $('#trigger_boards').selectize({
                    plugins: selectize_util.plugins($('#trigger_boards'), 'loading_spinner'),
                    create: $(this).data('tags') === true,
                    createOnBlur: $(this).data('tags') === true,
                });
                trigger_board = selectize_util.safeInstance($trigger_board);

                if (!trigger_board.hasOptions && $('#trigger_boards').data('loading-spinner')) {
                    trigger_board.load(function (callback) {
                        SelectizedForm.loading();
                        xhr && xhr.abort();
                        xhr = $.ajax({
                            type: 'GET',
                            url: reverse_url['automation:boards'](),
                            timeout: XHR_TIMEOUT,
                            global: false,
                            error: function () {
                                callback();
                                if (window.trigger_boards.length) {
                                    // we're editing an existing rule with trigger rules
                                    // saving would remove existing trigger rules so we disable the form
                                    SelectizedForm.displayError(trigger_board);

                                    selectize_util.createItems(trigger_board, window.trigger_boards);
                                } else {
                                    // we're not removing existing trigger rules - allow rule to be saved
                                    SelectizedForm.displayWarning(trigger_board);
                                }
                            },
                            success: function (data) {
                                var options = [];
                                SelectizedForm.hideError(trigger_board);
                                data.forEach(function (board) {
                                    options.push({
                                        'value': board.name,
                                        'text': board.name
                                    });
                                });
                                callback(options);

                                function findValueByName(board_name) {
                                    options.forEach(function (option) {
                                        if (option.text === board_name) {
                                            return option.value;
                                        }
                                    });
                                }

                                if (window.trigger_boards) {
                                    window.trigger_boards.forEach(function (board_name) {
                                        trigger_board.addItem(board_name);
                                    });
                                }
                            }
                        });
                    });
                } else {
                    if (window.trigger_boards) {
                        window.trigger_boards.forEach(function (board_name) {
                            trigger_board.addItem(board_name);
                        });
                    }
                }
            }
        }

        function updateWidgetVisibility(event) {

            $('form.form-horizontal').find('.' + SelectizedForm._alertClass('error')).addClass("collapse")

            var triggerType = $('#trigger_type').val();
            var actionType = $('#action_type').val();
            var toggler = event ? toggleWidgetToState : setVisibility; // initialize with just the CSS class, on later switches trigger the animation
            toggler($('#widget-tags'), triggerType == 'TAG_ADDED');
            toggler($('#widget-status'), triggerType == 'STATUS_CHANGED');
            toggler($('#widget-action-recipients'), actionType == 'SEND_EMAIL');
            toggler($('#widget-action-note-type'), actionType == 'ATTACH_NOTE');
            toggler($('#widget-action-customer-has-updated'), actionType == 'ATTACH_NOTE');
            toggler($('#widget-action-note-note'), actionType == 'ATTACH_NOTE');
            toggler($('#widget-action-board'), actionType == 'CHANGE_STATUS');
            toggler($('#widget-action-category'), actionType == 'CHANGE_CATEGORY');
            toggler($('#widget-action-type'), actionType == 'CHANGE_TYPE');
            toggler($('#widget-action-survey-note'), actionType == 'SUBMIT_SURVEY');

            toggler($('.action_js'), false);
            toggler($('#' + actionType), true);

            $('#' + actionType + ' [data-load]').each(function (i, element) {
                loadData($(element));
            });


            toggler($('#widget-action-due-within'), actionType == 'CREATE_TASK');
            toggler($('#submit-review-alert'), actionType == 'FD_SATISFACTION_RATING');
            toggler($('#widget-action-submit-satisfaction-rating-zendesk'), actionType == 'ZD_SUBMIT_REVIEW');

            if (actionType == 'CHANGE_STATUS') {
                fetchBoardsAndStatuses();
            } else if (actionType == 'CHANGE_TYPE') {
                fetchTicketTypes();
            } else if (actionType == 'CHANGE_CATEGORY') {
                fetchTicketCategories();
            } else {
                // hide error states - fetchBoardsAndStatuses() will check for errors again...
                var actionBoardSelectize = selectize_util.optionalInstance($('#action_board')),
                    actionStatusSelectize = selectize_util.optionalInstance($('#action_status'));

                if (actionBoardSelectize) {
                    SelectizedForm.hideError(actionBoardSelectize);
                }
                if (actionStatusSelectize) {
                    SelectizedForm.hideError(actionStatusSelectize);
                }
            }

            toggler($('#widget-action-status'), actionType == 'CHANGE_STATUS');
            if (actionType == 'CREATE_TICKET') {
                validateCreateOwnerPermissions();
            }

            if (actionType === "SEND_EMAIL_TO_CONTACT" && !quill) {
                textArea = document.querySelector("#respondToContactBody");
                quill = new Quill('#quillEditor', {
                    modules: {
                        toolbar: '#quillToolbar'
                    },
                    placeholder: "Write the email that will be sent to your contacts here. You can style the text and embed URLs with the buttons above, and you can insert placeholders with the options below.",
                });

                let quillEditorBody = document.querySelector("#quillEditor .ql-editor");
                quillEditorBody.innerHTML = textArea.value;

                quill.on('text-change', () => {
                    textArea.value = quill.root.innerHTML;
                });

                initQuillEventListeners();
            }
        }

        function updateCheckboxDisabledness(event) {
            $('#trigger_has_clearance_for_publishing').prop('disabled', !$('#trigger_has_comment').prop('checked'));
            // when the comment flag is unchecked, the cleared for publishing flag should not only be disabled, but also unchecked!
            if (!$('#trigger_has_comment').prop('checked')) {
                $('#trigger_has_clearance_for_publishing').prop('checked', false);
            }
        }

        function validateNotEmpty(field) {
            if (field.val() && field.val().length > 0) {
                return null;
            } else {
                return 'This field is required.'
            }
        }

        function validateEmail(email) {
            if (email.val().length === 0) {
                return 'Email is required.';
            }

            var re = /(^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$)/;

            var notValid = email.val().filter(function (val) {
                return !re.test(val.toLowerCase())
            });
            if (notValid.length === 0) {
                return null;
            } else {
                return notValid.length > 1 ? 'Emails is not valid.' : 'Email is not valid.';
            }

        }

        function validateCreateOwnerPermissions() {
            if ($('.perm_error_js').length) {
                $.ajax({
                    'url': reverse_url['ticketsource:validate-owner-perm'](),
                    'async': true,
                    'success': function (perm_check) {
                        if (perm_check.pass) {
                            $('.perm_error_js').addClass('collapse');
                        } else {
                            $('.perm_error_js').removeClass('collapse');
                        }
                    }
                });
            }
        }

        function validateField(fieldSelector, validator) {
            var fieldElement = $(fieldSelector);
            var fieldElementContainer = fieldElement.parent();
            var formGroup = fieldElement.closest('.form-group');
            var validationError = validator(fieldElement);
            fieldElementContainer.find('span.help-block').remove();
            if (validationError !== null) {
                fieldElementContainer.append('<span class="help-block"><strong>' + validationError + '</strong></span>');
                formGroup.addClass('has-error');
                return false;
            } else {
                formGroup.removeClass('has-error');
                return true;
            }
        }

        function validateTriggers() {
            var triggerType = $('#trigger_type').val();
            if (triggerType === 'TAG_ADDED') {
                return validateField('#trigger_tags', validateNotEmpty);
            } else if (triggerType === 'STATUS_CHANGED') {
                return validateField('#trigger_status', validateNotEmpty);
            }
            return true;
        }

        function validateActions() {
            var actionType = $('#action_type').val();
            if (actionType === 'CHANGE_STATUS') {
                return validateField('#action_board', validateNotEmpty) && validateField('#action_status', validateNotEmpty);
            } else if (actionType === 'SEND_EMAIL') {
                return validateField('#action_recipients', validateEmail);
            }
            return true;
        }

        function onSaveButton(event) {
            let validFields = true;
            let nameInput = document.querySelector("input[name='name']");
            let nameErrorNode = document.querySelector(".name-error");
            if (!nameInput.value.length) {
                validFields = false;
                nameInput.classList.add("error")
                nameErrorNode.classList.remove("hide");
            } else {
                nameInput.classList.remove("error")
                nameErrorNode.classList.add("hide");
            }

            let actionType = $('#action_type').val();
            if (actionType === "CREATE_TICKET") {
                let ticketTitle = $('#ticket_title');
                if (ticketTitle.length) {
                    let errorNode = $(".create-ticket-tile-error");
                    if (!ticketTitle.val()) {
                        validFields = false;
                        errorNode.text("Please enter a title")
                        errorNode.removeClass("hide");
                        ticketTitle.addClass("error");
                    } else if (ticketTitle.val().length > ticketTitle.attr("maxlength")) {
                        validFields = false;
                        errorNode.text(`Please limit title to ${ticketTitle.attr("maxlength")} characters`)
                        errorNode.removeClass("hide");
                        ticketTitle.addClass("error");
                    } else {
                        errorNode.addClass("hide");
                        ticketTitle.removeClass("error");
                    }
                }
            }

            if (actionType === "SEND_EMAIL_TO_CONTACT") {
                let emailSubject = document.querySelector("#respondToContactSubject");
                let emailBody = document.querySelector("#respondToContactBody")
                let quillBody = document.querySelector("#quillEditor");
                let quillInside = quillBody.querySelector(".ql-editor");

                // take the Quill Rich Text value and add it to #respondToContactBody for submit
                emailBody.value = quill.root.innerHTML;

                if(emailSubject.value.trim() === '') {
                    validFields = false;
                    let errorNode = document.querySelector(".respond-to-contact-subject-error");
                    errorNode.classList.remove("hide");
                    emailSubject.classList.add("danger");
                }

                // use regex to check if quill editor is empty - ignoring empty tags
                var regex = /(<([^>]+)>)/ig
                if(emailBody.value.replace(regex, "").length === 0) {
                    validFields = false;
                    let errorNode = document.querySelector(".respond-to-contact-email-error");
                    errorNode.innerText = errorNode.dataset.empty;
                    errorNode.classList.remove("hide");
                    quillInside.classList.add("danger");
                }

                if(emailBody.value.indexOf("<a href=") > -1 && (emailBody.value.indexOf('<a href="http') === -1 && emailBody.value.indexOf('<a href="mailto') === -1)) {
                    validFields = false;
                    let errorNode = document.querySelector(".respond-to-contact-email-error");
                    errorNode.innerText = errorNode.dataset.improperLink;
                    errorNode.classList.remove("hide");
                    quillInside.classList.add("danger");
                }
            }

            var triggersValidated = validateTriggers();
            var actionsValidated = validateActions();
            if (triggersValidated && actionsValidated && validFields) {
                browser_storage.setItem("automation-edited", ruleID);
                $('form').submit();
            } else {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(".error:visible").offset().top
                }, 400);
            }
        }

        let insertAtCursor = (field, value) => {
            //IE support
            if (document.selection) {
                field.focus();
                sel = document.selection.createRange();
                sel.text = value;
            } else if (field.selectionStart || field.selectionStart == '0') {
                var startPos = field.selectionStart;
                var endPos = field.selectionEnd;
                field.value = field.value.substring(0, startPos) +
                    value +
                    field.value.substring(endPos, field.value.length);
            } else {
                field.value += value;
            }
        }

        let addVariablePlaceholder = (event) => {
            event.preventDefault();
            let link = event.target;
            let variable = link.dataset.variable_for;
            let input = document.querySelector(`#${variable}`)

            if (input.tagName === "DIV") {
                let position = quill.getSelection() || {
                    index: 0,
                    length: 0
                };
                quill.insertText(position.index + position.length, `{${link.dataset.variable}}`);
            } else {
                insertAtCursor(input, `{${link.dataset.variable}}`);
                link.classList.add("disabled");
                input.click();
            }
        }

        let toggleLinkState = (input, links) => {
            let passingCondition;
            links.forEach(link => {
                // when using Quill textarea, we need to read inside a DIV, rather than an input value
                if (input.tagName === "DIV") {
                    passingCondition = input.innerHTML.indexOf(`{${link.dataset.variable}}`) > -1;
                } else {
                    passingCondition = input.value.indexOf(`{${link.dataset.variable}}`) > -1
                }

                if (passingCondition) {
                    link.classList.add("disabled");
                } else {
                    link.classList.remove("disabled");
                }
            })
        }

        let addVariableFunctionality = (inputSelector, variableWrapSelector) => {
            let input = document.querySelector(inputSelector)
            let variableWrap = document.querySelector(`.variable-wrap${variableWrapSelector}`);
            if (!input) return;

            let addVariableLinks = variableWrap.querySelectorAll("a.add-variable");

            toggleLinkState(input, addVariableLinks);

            addVariableLinks.forEach(link => {
                link.addEventListener("click", addVariablePlaceholder);
            })

            input.addEventListener("keyup", () => {
                toggleLinkState(input, addVariableLinks);
            })
        }

        let initQuillEventListeners = () => {
            let textArea = document.querySelector('#respondToContactBody');
            let quillTextArea = document.querySelector('#quillEditor');

            if(!quillTextArea || quillInitiated) return;

            quillInitiated = true;
            
            function htmlToText(html) {
                var temp = document.createElement('div');
                temp.innerHTML = html;
                return temp.textContent; // Or return temp.innerText if you need to return only visible text. It's slower.
            }

            //special character count for Quill editor, since it is unique                
            let currentLength = htmlToText(quillTextArea.innerHTML).length;
            let limit = 500;

            quillTextArea.insertAdjacentHTML('afterend', `<div data-limit="${limit}" class="char-count"><span class="current">${currentLength}</span> / ${limit}</div>`);
            let limitMet = false;

            let execution = (event) => {
                currentLength = htmlToText(quillTextArea.innerHTML).length;
                let countEl = quillTextArea.parentNode.querySelector(".char-count");
                let countSpan = countEl.querySelector(".current");

                countSpan.innerText = currentLength;

                if (currentLength > limit) {
                    countEl.classList.add("error");
                    quillTextArea.classList.add("danger");
                    limitMet = true;
                    return;
                }

                if (limitMet && currentLength <= limit) {
                    countEl.classList.remove("error");
                    quillTextArea.classList.remove("danger");
                    limitMet = false;
                }
            }

            quillTextArea.addEventListener("keyup", execution);
            quillTextArea.addEventListener("click", execution);

            quillTextArea.addEventListener("paste", (event) => {
                // prevent pasting of anything but text, and update cursor position after pasting
                let text = (event.clipboardData || window.clipboardData).getData("text");
                event.preventDefault();
                if(text) {
                    let originalIndex = quill.getSelection().index;
                    quill.updateContents(new Delta()
                        .retain(quill.getSelection().index)
                        .insert(text)
                    );
                    setTimeout(() => {
                        quill.setSelection(originalIndex + text.length, 0)
                    }, 10)
                }
            });
        }

        return {
            init: function () {
                // initially update the visibility of the various UI widgets
                updateWidgetVisibility(null);
                updateCheckboxDisabledness(null);

                // connect event handlers
                $('#trigger_type, #action_type, #action_customer_has_updated').change(updateWidgetVisibility);
                $('#trigger_has_comment').change(updateCheckboxDisabledness);
                $('#automation-edit-button-save').click(onSaveButton);

                addVariableFunctionality("#ticket_title", ".create-ticket");

                utilities.enableInputResets();
                utilities.addCharacterCount("#ticket_title", 70);

                let disableMarketingCheckbox = () => {
                    $("#trigger_has_clearance_for_publishing").prop("checked", false);
                    $(".has-marketing-permissions").addClass("disabled");
                }
                
                $("#trigger_has_comment").change(event => {                    
                    if(event.target.checked){
                        $(".has-marketing-permissions").removeClass("disabled");
                        $("#trigger_has_no_comment").prop("checked", false);
                    } else {
                        disableMarketingCheckbox();
                    }
                })

                $("#trigger_has_no_comment").change(event => {
                    if(event.target.checked){
                        $("#trigger_has_comment").prop("checked", false);
                        disableMarketingCheckbox();
                    }
                });

                if($("#trigger_has_comment")[0].checked) {
                    $(".has-marketing-permissions").removeClass("disabled");
                }

                // prepare trigger board select fields
                initializeTriggerBoardsOnFocus();

                // once all this is done, hide the loading animation
                loading_animation.complete();

                if(tssType === "cw") {
                    utilities.addCharacterCount("#respondToContactSubject", 60)
                    addVariableFunctionality("#respondToContactSubject", ".respond-to-contact-subject");
                    addVariableFunctionality("#quillEditor", ".respond-to-contact-body");
                    
                    utilities.enableLogoPicker(nodes.modal);

                    nodes.emailPreview.button.addEventListener("click", (event) => {
                        event.preventDefault();
                        nodes.emailPreview.logo.classList.remove("visible")
                        nodes.emailPreview.body.innerHTML = "";

                        let logo = document.querySelector(".uploader__withlogo");

                        if(logo && !logo.classList.contains("disabled")) {
                            // add logo to preview
                            nodes.emailPreview.logo.style = logo.getAttribute("style");
                            nodes.emailPreview.logo.classList.add("visible")
                        }

                        let htmlBody = quill.root.innerHTML;
                        htmlBody = htmlBody.replace("{first_name}", "Alex");
                        htmlBody = htmlBody.replace("{review}", "positive");
                        htmlBody = htmlBody.replace("{ticket_id}", "#123456");
                        nodes.emailPreview.body.innerHTML = htmlBody;
                        
                        createdModal.open(null, () => {}, nodes.emailPreview.modalTemplate);  
                    })
                }
            }
        }
    }
);